<!-- 角色申请详情 -->
<template>
  <div class="workOrder">
    <div class="container">
      <div class="order_detail-title">角色申请详情</div>
      <div class="order_detail-role">
        <el-form :model="showInfo" label-width="100px" class="demo-ruleForm">
          <el-form-item label="申请角色">
            <el-input v-model="showInfo.roleType" disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-input v-model="showInfo.requestTime" disabled="true"></el-input>
          </el-form-item>
          <el-form-item class="orderInput" label="备注">
            <el-input disabled="true" type="textarea" :rows="6" v-model="showInfo.requestRemark"></el-input>
          </el-form-item>
          <el-form-item label="审批状态">
            <el-input v-model="stateMap[showInfo.status]" disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="审批时间">
            <el-input v-model="showInfo.approvalTime" disabled="true"></el-input>
          </el-form-item>
          <el-form-item class="orderInput" label="审批意见">
            <el-input disabled="true" type="textarea" :rows="6" v-model="showInfo.approvalRemark"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import * as types from "../../vuex/types/type";
import workApi from "../../api/personalCenter/work";
import moment from 'moment';

export default {
  data() {
    return {
      stateMap: {
        0: "待审批",
        1: "审批通过",
        2: "审批不通过",
        3: "审批中"
      },
      showInfo: {},
    };
  },
  methods: {
    ...mapActions({
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    // 格式化时间
    formatDate (data) {
      const date = data;
      if (date == undefined) {
        return '--';
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    // 获取角色申请详情
    getRoleRequestDetail(id) {
      workApi.getRoleRequestDetail({
        roleRequestId: id
      }).then(res => {
        const resData = res.data
        if (resData.code == 0) {
          this.showInfo = resData.result
          this.showInfo.requestTime = this.formatDate(this.showInfo.requestTime);
          this.showInfo.approvalTime = this.formatDate(this.showInfo.approvalTime);
        } else {
          this.setFailMessage({
            show: true,
            content: resData.msg || "获取失败"
          });
        }
      })
    },
  },
  created() {
    let id = this.$route.query.roleRequestId
    this.getRoleRequestDetail(id)
  },
};
</script>

<style lang="scss">
.order_detail-title {
  margin-bottom: 15px;
  font-size: 16px;
}
.orderInput {
  height: initial !important;
}
.order_detail-role{
  width: 50%;
  margin-left: 150px;
}
</style>



// WEBPACK FOOTER //
// roleApplyDetails.vue?fd0a90e2